import { Component, OnInit } from '@angular/core';
import { LoaderService } from '@core/services/loader.service';
import { RegistrationPreSorteoGna } from '../../../models/registration-pre-sorteo-gna.model';
import { RegistrationPresorteoService } from '../../../services/registrationPresorteo/registration-presorteo.service';

@Component({
  selector: 'app-page-selection-report',
  templateUrl: './page-selection-report.component.html',
  styleUrls: ['./page-selection-report.component.scss']
})
export class PageSelectionReportComponent implements OnInit {

  registrations: RegistrationPreSorteoGna[] = null;
  constructor(
    private loadService: LoaderService,
    private registrationService: RegistrationPresorteoService
  ) { }

  ngOnInit(): void {
    this.getRegistrations();
  }

  getRegistrations() {
    this.loadService.show();
    this.registrationService.getRegistrations()
    .then(response => {
      if (response.success) {

        this.registrations = response.data;
      }
    })
    .finally(() => {
      this.loadService.hide();
    });
  }

}
